import React, {useEffect, useState} from 'react';
import Select, {components} from 'react-select';
import RolePermissionsReadOnly from '../Role/RolePermissionsReadOnly';
import { DropdownIndicator } from '../CustomDropdownIndicator/CustomDropdownIndicator'
import { formatTestId } from '../../util/EfupUtility';

const Option = (props) => {
    const selectType = props.selectProps.customProps.selectType;
    const testId = formatTestId(`${selectType}-${props.data.roleName}-option`)
    return (
        <components.Option {...props} className={`efup-filter-option efup-${selectType}-dropdown-option`}>
            <label data-testid={testId}>{props.data.roleName}</label>
        </components.Option>
    );
};

const SingleValue = ({ children, ...props }) => {
    const selectedValue = props.selectProps.value;
    const selectType = props.selectProps.customProps.selectType;
    return (
        <components.SingleValue {...props} className={`efup-filter-option efup-${selectType}-dropdown-option`}>
            <label className="dropdown-single-value-select" data-testid='role-selected-value'>{selectedValue.roleName}</label>
        </components.SingleValue>
    );
};

const customStyles = {
    control: (styles, { isDisabled, isFocused, isSelected }) => {
        return {
            ...styles,
            borderRadius: 0,
            boxShadow: isFocused || isSelected ? '0 0 5px #8ae0f1' : undefined,
            border: isDisabled
                ? undefined
                : isSelected || isFocused
                    ? '1px solid #E8E8E8'
                    : '1px solid #909199',
            ':hover': {
                borderColor: isSelected || isFocused ? '#E8E8E8'
                    : '#909199',
            }
        }
    },
    option: (styles, { isDisabled, isFocused, isSelected }) => {
        return {
            ...styles,
            backgroundColor: isDisabled
                ? undefined
                : isSelected && !isFocused
                    ? 'transparent'
                    : isFocused
                        ? '#00b5e2'
                        : undefined,
            cursor: isDisabled ? 'not-allowed' : 'default',

            ':active': {
                ...styles[':active'],
                backgroundColor: !isDisabled
                    ? isSelected
                        ? '#00b5e2'
                        : '#00b5e2'
                    : undefined,
            },
            ':hover': {
                backgroundColor: !isDisabled
                    ? isSelected
                        ? '#00b5e2'
                        : '#00b5e2'
                    : undefined,
            }
        };
    },
}

export default function UserRoleInformation(props) {
    const { handleFieldUpdate, errors, availableRoles, existingRoleUuid } = props;
    const [selectedRole, setSelectedRole] = useState(undefined);

    const handleRoleUpdate = (role) => {
        setSelectedRole(role);
        handleFieldUpdate("companyRole", role);
    };

    useEffect (() =>{
        setSelectedRole(availableRoles !== 'undefined' ? availableRoles.filter(role => {
            return role.roleUuid === existingRoleUuid;
            })[0] : undefined)
    },[availableRoles,existingRoleUuid])

    return (
        <><div className="row">
            <div className="col">
                <div className='cb-form-group'>
                    <label className='fieldLabel'>Company Role*</label>
                    <Select
                        value={selectedRole}
                        className="dropdown"
                        onChange={handleRoleUpdate}
                        placeholder="Select a role"
                        components={{
                            DropdownIndicator,
                            SingleValue,
                            Option}}
                        customProps={{ selectType:'role' }}
                        options={availableRoles}
                        styles={customStyles}
                        errorKey="role"
                        errors={errors?.role}
                        formName="userInfo"
                        noOptionsMessage={()=>'No roles for company'}
                    />
                </div>
            </div>
            <div className="col">
                <div className='cb-form-group'>
                    <label className='fieldLabel'>Description</label>
                    <div className='role-description'>{selectedRole?.description}</div>
                </div>
            </div>
            <div className="col">
            </div>
        </div>
        <div className="row">
            <div className="permissions-container" data-testid="role-permission-list">
                <RolePermissionsReadOnly permissions={selectedRole?.permissions} />
            </div>
        </div></>
    );
}